
import React from 'react'
import Layout from '../../components/layout'

import EmployeeCard from '../../components/employeecard'

// Avatars
import avatar_jl from '../../assets/employees/johan-profil.jpg'
import avatar_gl from '../../assets/employees/gustav-profil.jpg'
import avatar_rn from '../../assets/employees/robert-profil.jpg'
import avatar_dh from '../../assets/employees/david-profil.jpg'
import avatar_jh from '../../assets/employees/jocke-profil.jpg'
import avatar_db from '../../assets/employees/dennis-profil.jpg'
import avatar_ml from '../../assets/employees/mattias-profil.jpg'
import avatar_me from '../../assets/employees/malin-profil.jpg'
import avatar_el from '../../assets/employees/emanuel-profil.jpg'
import avatar_il from '../../assets/employees/isak-profil.JPG'
import avatar_kg from '../../assets/employees/kalle-profil.jpg'
import avatar_ev from '../../assets/employees/emil-profil.jpg'

// Certlogos
import CCNA from '../../assets/certifications/ccna.jpg'
import CCIE_E from '../../assets/certifications/ccie_enterprise.jpg'
import CCIE_DC from '../../assets/certifications/ccie_datacenter.jpg'
import CCIE_SP from '../../assets/certifications/ccie_servprov.jpg'
import CCIE_S from '../../assets/certifications/ccie_security.jpg'
import CCDE from '../../assets/certifications/ccde_design.jpg'

import CCDP from '../../assets/certifications/ccdp.jpg'
import CCDevP from '../../assets/certifications/devnet_professional.png'
import CCDevA from '../../assets/certifications/devnet_associate.png'
import CCDevE from '../../assets/certifications/devnet_expert.png'

import D500 from '../../assets/certifications/devnet500.jpg'
import CCNP_ENT from '../../assets/certifications/ccnp_enterprise.jpg'
import CCNP_SP from '../../assets/certifications/ccnp_sp.jpg'
import ENCOR from '../../assets/certifications/cisco_specialist.jpg'


const employees = [
  {
    name: "Johan Lahti",
    avatar: avatar_jl,
    title: "Sr. Consultant & CEO",
    certifications: [
      { name: "CCIE R&S", logo: CCIE_E },
      { name: "DevNet Professional", logo: CCDevP },
      { name: "CCDP", logo: CCDP },
      { name: "DevNet500", logo: D500 }
    ],
    text: "Johan är grundare av Acebit och har över 15 års erfarenhet av IT-branschen och framförallt nätverk. Han är tungt tekniskt certifierad och innehar bland annat Ciscos högsta nivå - CCIE R&S, och även DevNet Professional och CCDP. Johan har också fått andra utmärkelser såsom DevNet500 och Cisco Champion (2022, 2023 2024)."
  },
  {
    name: "Gustav Larsson",
    avatar: avatar_gl,
    title: "Sr. Consultant",
    certifications: [
      { name: "CCIE R&S", logo: CCIE_E },
      { name: "DevNet Expert", logo: CCDevE }
    ],
    text: "Gustav har på kort tid tagit sig väl in i IT-branchen - och på bara 5 år åstadkommit att bli Cisco CCIE inom Enterprise samt Cisco DevNet Expert certifierad, samt satsat hårt på att spetsa kompetensen kring systemutveckling, med fokus på att skapa applikationer och system som löser verksamhetsbehov inom infrastruktur."
  },
  {
    name: "Robert Nilsson",
    avatar: avatar_rn,
    title: "Sr. Consultant & Manager",
    certifications: [
      { name: "CCNP Enterprise", logo: CCNP_ENT },
      { name: "CCNP Service Provider", logo: CCNP_SP },
      { name: "DevNet Associate", logo: CCDevA }
    ],
    cert_logos: [],
    text: "Robert har jobbat med datornätverk i mer än 10 år. Han har erfarenhet av datacenter-, tjänsteleverantörs- och kontorsnät; detta ger honom en bred förståelse för olika behov och teknologier. Robert är även certifierad DevNet Associate och CCNP inom både Routing & Switching (idag Enterprise) och Service Provider."
  },
  {
    name: "Joakim Hag",
    avatar: avatar_jh,
    title: "Consultant",
    certifications: [
      { name: "CCNP Enterprise", logo: CCNP_ENT },
      { name: "DevNet Professional", logo: CCDevP },
    ],
    cert_logos: [],
    text: "Joakim har över 10 års erfarenhet av IT-branschen, sedan 2016 har hans fokus varit nätverk. Han är certifierad CCNP inom Routing & Switching (idag Enterprise), DevNet Specialist på Enterprise spåret och DevNet Professional."
  },
  {
    name: "Emil Vonck",
    avatar: avatar_ev,
    title: "Sr. Consultant",
    certifications: [
      { name: "DevNet Expert", logo: CCDevE },
      { name: "CCNP Enterprise", logo: CCNP_ENT },
    ],
    cert_logos: [],
    text: "Emil har en lång bakgrund inom nätverk och infrastruktur, men har på senare tid specialiserat sig inom nätverksautomation och programmering. Emil är certifierad Cisco DevNet Expert samt CCNP Enterprise, och har stor erfarenhet av att hjälpa kunder med att automatisera och effektivisera sina nätverksmiljöer."
  },
  {
    name: "Dennis Bäckstedt",
    avatar: avatar_db,
    title: "Consultant",
    certifications: [],
    text: "Dennis har arbetat inom IT i snart 10 år. Han har bred erfarenhet av Cisco-produkter och är särskilt inriktad på arbete med Wi-Fi-lösningar innefattande design, implementation och felsökning. Dennis värdesätter att verkligen förstå sina kunders verksamhet, inte bara IT-delen, vilket han anser är avgörande för att leverera en bra lösning."
  },
  {
    name: "Mattias Liljestrand",
    avatar: avatar_ml,
    title: "Consultant",
    certifications: [
      { name: "CCNA", logo: CCNA },
      { name: "CCNP Enterprise", logo: CCNP_ENT },
    ],
    text: "Mattias har en bakgrund som professionell fotbollsspelare under hela yrkeslivet och har nu bytt bana till IT. Efter att ha genomfört en YH-utbildning i Moln och virtualisering, samt praktik hos Acebit, har Mattias tagit steget in i nätverksbranschen. Han har idag, bara något år in i branschen, redan certifierat sig till CCNA och CCNP Enterprise."
  },
  {
    name: "Isak Ljunggren",
    avatar: avatar_il,
    title: "Consultant",
    certifications: [
      { name: "CCNA", logo: CCNA }
    ],
    text: "Isak har på kort tid kommit in starkt i IT-branchen, med goda kunskaper inom systemutveckling och DevOps-arbetssätt har han kunnat bidra från start med att hjälpa våra kunder bygga nätverk på det moderna, skalbara sättet Acebit bygger framtidens nätverk."
  },
  {
    name: "David Heidenberg",
    avatar: avatar_dh,
    title: "Consultant",
    certifications: [
      { name: "CCNA", logo: CCNA },
    ],
    text: "David är nytt stjärnskott till branschen som på kort tid kommit in med stort driv, nyfikenhet och vilja att lära sig allt inom nätverk och infrastruktur. David har arbetat mycket med Aruba Wireless, och tagit en Cisco CCNA Certifiering. Med god kundkontakt och proffsigt bemötande finns det inga utmaningar han inte kan lösa!"
  },
  {
    name: "Kalle Gustafsson",
    avatar: avatar_kg,
    title: "Account Manager",
    certifications: [],
    text: "Kalle har över 10 års erfarenhet av sälj inom olika tekniska områden. både B2C samt B2B försäljning av ruggad hårdvara till företag inom tung industri. Nu är siktet inställt på att hjälpa företag och organisationer att få bättre, säkrare och mer lättskötta nätverk tillsammans med teamet på Acebit!"
  },
  {
    name: "Malin Ekstrand",
    avatar: avatar_me,
    title: "Administrator",
    certifications: [],
    text: ""
  },
  {
    name: "Emanuel Lipschütz ",
    avatar: avatar_el,
    title: "Chariman of the board",
    certifications: [
      { name: "CCIE R&S", logo: CCIE_E },
      { name: "CCIE DC", logo: CCIE_DC },
      { name: "CCIE SP", logo: CCIE_SP },
      { name: "CCIE Sec", logo: CCIE_S },
      { name: "CCDE", logo: CCDE }
    ],
    text: "Emanuel är styrelseordförande i Acebit och har över 25 års erfarenhet inom nätverk och cybersäkerhet och jobbat med ett stort antal företag och organisationer inom olika vertikaler. Emanuel har tagit inte mindre än 4 CCIE certifieringar, R&S, Security, Service Provider och Datacenter. Han har även motsvarande certifiering inom design, CCDE. Emanuel är också instruktör och är ensam i Sverige med att ha fått utmärkelsen Sirius Top Quality Instructor Award av Cisco. Emanuel är serieentreprenör och har fått utmärkelser och erkännande för det, bla Årets Företagare Stockholm Stad 2010."
  }
]

export default function EmployeesPage() {

  return (
    <Layout>
      <div id="about" className="section">
        <div className="flex flex-col gap-6">
          <h1 className="text-4xl text-center">Vi är <span className="text-sky-500">ACEBIT</span></h1>

          <div className="grid flex-wrap justify-center grid-cols-2 sm:grid-cols-4 gap-4">

            {employees.map((item, index) => (
              <EmployeeCard
                key={index}
                name={item.name}
                avatar={item.avatar}
                title={item.title}
                certifications={item.certifications}
                text={item.text}
              />
            ))}

          </div>
        </div>
      </div>
    </Layout>
  )
}
